import * as Yup from 'yup';

export const FirmPortfolioEditCriteriaFormValidationSchema = Yup.object().shape(
  {
    Criteria: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters'),

    Sector: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters'),

    Style: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters'),

    Size: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters'),

    Geography: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters'),
  }
);
